import {
    Component,
    OnInit,
    ViewEncapsulation,
    ElementRef,
    Input
} from '@angular/core';
import { Helpers } from '../../../../../../helpers';
import { Router } from '@angular/router';
import { DatatableComponent } from '../../../datatable.component';
import { UserGroupService } from '../../../../../../services/user-group.service';
import { Paths } from '../../../../../../models/enums';
import { DataService } from '../../../../../../_services/data.service';

@Component({
    selector: 'app-user-group-list',
    templateUrl: './list-user-group.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListUserGroupComponent extends DatatableComponent
    implements OnInit {
    updateTrigger() {
        this.router.navigate(['/' + this.path + '/usergroup/update', this.id], {
            queryParams: {
                publisherId: this.publisherId,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }
    deleteTrigger() {
        this.deleteRow(this.id);
    }
    buildDatatableParams() {
        this.selectorId = 'user-group-datatable';
        this.datatableUrl = '/usergroups/list?filterId=' + this.publisherId;
        this.columns = [
            {
                field: 'name',
                title: 'Name',
                template: function(row) {
                    return row.name;
                }
            },
            {
                field: 'Actions',
                width: 80,
                title: 'Actions',
                sortable: false,
                overflow: 'visible',
                textAlign: 'center',
                template: function(row) {
                    return (
                        '\
                    <button data-id="' +
                        row.id +
                        '" id="updateUser' +
                        row.id +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>\
                    <button data-id="' +
                        row.id +
                        '" id="deleteUser' +
                        row.id +
                        '" (click)="deleteUser( ' +
                        row.email +
                        ')" class="delete-row m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete "><i class="la la-trash"></i></button>\
                '
                    );
                }
            }
        ];
    }

    datatable: any;
    path: string;
    @Input() publisherId: string;
    @Input() routePath: string;
    @Input() publisherName: string;

    constructor(
        private userGroupService: UserGroupService,
        protected el: ElementRef,
        private router: Router,
        private dataService: DataService
    ) {
        super(el);
        this.path = Helpers.getPath();
        if (!this.routePath) this.routePath = this.path + '/usergroup/list';
        if (this.path == Paths.Publisher) {
            const profile = dataService.getUser();
            this.publisherId = profile.publisherId;
        }
    }

    ngOnInit() {
        this.buildDatatable();
    }

    onClickCreateUserGroup() {
        this.router.navigate(['/' + this.path + '/usergroup/create'], {
            queryParams: {
                publisherId: this.publisherId,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }

    deleteRow(userGroupId: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                Helpers.setLoading(true);
                this.userGroupService.delete(userGroupId).subscribe(() => {
                    Helpers.setLoading(false);
                    this.swalService.successDelete();
                    this.datatable.load();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/user-group/list-user-group/list-user-group.component.ts